import { Link } from "react-router-dom";
import { Type } from "@shared/ui/Type";
import { PollinatorLogo } from "@shared/ui/PollinatorLogo";
import { OuterContentContainer } from "@shared/ui/OuterContentContainer";
import { platformFooterItems } from "./platformFooterItems";

export function PlatformAppFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <OuterContentContainer as="footer" className="border-t border-brand-800">
      <div className="flex flex-col gap-12 py-8 w-full">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {platformFooterItems.map((section, sectionIndex) => (
            <div key={sectionIndex} className="flex flex-col gap-2">
              <Type variant="caption" className="font-medium">
                {section.title}
              </Type>
              <div className="flex flex-col gap-2">
                {section.links.map((link, linkIndex) => {
                  return (
                    <Type
                      as={link.isExternal ? "a" : Link}
                      key={linkIndex}
                      href={link.url}
                      to={link.url}
                      target={link.isExternal ? "_blank" : "_self"}
                      variant="caption"
                      className="hover:text-brand-700"
                      data-testid={`platform-footer-${section.title
                        .toLowerCase()
                        .replace(/\s+/g, "-")}-${link.title
                        .toLowerCase()
                        .replace(/\s+/g, "-")}`}
                    >
                      {link.title}
                    </Type>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
        <div className="flex flex-col items-start justify-between gap-2 md:flex-row md:items-center">
          <PollinatorLogo size="md" />
          <Type variant="caption">© {currentYear} Pollinator</Type>
        </div>
      </div>
    </OuterContentContainer>
  );
}

export default PlatformAppFooter;
